import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

const SimplePayStatus = ({ status, id }) => {
  // az ipn lehetseges statuszai az OTP doksi alapjan
  const statusTypes = {
    INIT: 'A tranzakció létrejött.',
    TIMEOUT: 'Időtullépés.',
    CANCELLED: 'Megszakított fizetés.',
    NOTAUTHORIZED: 'Sikertelen authorizáció.',
    INPAYMENT: 'Fizetés folyamatban.',
    INFRAUD: 'Csalásszűrés futása, vizsgálat alatt.',
    AUTHORIZED: 'Sikeres authorizáció',
    FRAUD: 'Csalás gyanú',
    REVERSED: 'Zárolt összeg visszafordítva',
    REFUND: 'Visszatérítés',
    FINISHED: 'Sikeres tranzakció.'
  };

  const getText = () => {
    switch (status) {
      case 'SUCCESS':
        return (
          <>
            <div className="lds-spinner">
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
            <p>
              Sikeres tranzakció. SimplePay tranzakció azonosító: {id}, kérjük várjon.
            </p>
          </>
        );
      case 'FAIL':
        return (
          <d>
            <p>Sikertelen tranzakció. SimplePay tranzakció azonosító: {id}.</p>
            <p>
              Kérjük, ellenőrizze a tranzakció során megadott adatok helyességét.
              Amennyiben minden adatot helyesen adott meg, a visszautasítás okának
              kivizsgálása érdekében kérjük, szíveskedjen kapcsolatba lépni
              kártyakibocsátó bankjával.
            </p>
            <p>Rendelését nem tudtuk fogadni.</p>
          </d>
        );
      case 'TIMEOUT':
        return (
          <p>
            Ön túllépte a tranzakció elindításának lehetséges maximális idejét a SimplePay
            oldalon így a rendelését nem tudtuk fogadni
          </p>
        );
      case 'CANCEL':
        return (
          <p>
            Megszakított fizetés a SimplePay oldalán, megrendelését nem tudtuk fogadni!
          </p>
        );
      default:
        return <p>{statusTypes.status}</p>;
    }
  };

  return <Root>{getText()}</Root>;
};

export default SimplePayStatus;

SimplePayStatus.propTypes = {
  status: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
};

const ldsSpin = keyframes`
  0% {
      opacity: 1;
  }
  100% {
      opacity: 0;
  }
`;

const Root = styled.div`
  display: flex;
  height: 400px;
  justify-content: center;
  align-items: center;

  & .lds-spinner {
    color: rgb(231, 195, 122);
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  & .lds-spinner div {
    transform-origin: 40px 40px;
    animation: ${ldsSpin} 1.2s linear infinite;
  }
  & .lds-spinner div:after {
    content: ' ';
    display: block;
    position: absolute;
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: rgb(231, 195, 122);
  }
  & .lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
  }
  & .lds-spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
  }
  & .lds-spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
  }
  & .lds-spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
  }
  & .lds-spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
  }
  & .lds-spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
  }
  & .lds-spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
  }
  & .lds-spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
  }
  & .lds-spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
  }
  & .lds-spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
  }
  & .lds-spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
  }
  & .lds-spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
  }
`;
